import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  SubmitUserFeedbackData,
  SubmitUserFeedbackResponses,
  UserFeedbackComplaintCategory,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';
import type { ReplacePathParams } from '@/shared/utils/pathParams';

// Define feedback types locally to avoid error type issues
interface FeedbackPraise {
  kind: 'PRAISE';
}

interface FeedbackComplaint {
  kind: 'COMPLAINT';
  categories: [UserFeedbackComplaintCategory];
  comment?: string;
}

type Feedback = FeedbackPraise | FeedbackComplaint;

interface SubmitDuoFeedbackParams {
  userId: string;
  feedback: Feedback;
}

const getSubmitDuoFeedbackUrl = (
  userId: string | number,
): ReplacePathParams<SubmitUserFeedbackData['url']> =>
  `users/${userId.toString()}/feedback`;

export function useSubmitDuoFeedback() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, feedback }: SubmitDuoFeedbackParams) => {
      return PrivateApi.post(getSubmitDuoFeedbackUrl(userId), {
        json: { feedback },
      }).json<SubmitUserFeedbackResponses>();
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['duos'] });
    },
  });
}
